import { render, staticRenderFns } from "./sellDetail.vue?vue&type=template&id=04ee8a85&scoped=true&"
import script from "./sellDetail.vue?vue&type=script&lang=js&"
export * from "./sellDetail.vue?vue&type=script&lang=js&"
import style0 from "./sellDetail.vue?vue&type=style&index=0&id=04ee8a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ee8a85",
  null
  
)

export default component.exports